"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var lodash_1 = require("lodash");
var react_tracking_1 = require("react-tracking");
var qs_1 = require("qs");
var elog = require("../../elog");
var collapsing_facet_1 = require("../../components/collapsing_facet");
var tracker_1 = require("../../tracker");
var core_link_1 = require("../../components/core_link");
// this value must match the `nth-child` selector value in subcategory-nav.scss
var CMS_COLLAPSE_THRESHOLD = 11;
var COMPONENT_NAME = 'SubcategoryNav';
var SubcategoryNav = /** @class */ (function (_super) {
    tslib_1.__extends(SubcategoryNav, _super);
    function SubcategoryNav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubcategoryNav.prototype.renderplaceholderNav = function () {
        return (React.createElement("div", { className: "facet" },
            React.createElement("nav", null,
                React.createElement("ul", { className: "cms-facet__options cms-facet__options--placeholder" }, lodash_1.times(6, function (idx) {
                    return (React.createElement("li", { className: "cms-facet__option", key: idx },
                        React.createElement("a", { href: "#", className: "cms-facet__link" },
                            React.createElement("div", { className: "cms-facet__link__image__wrap" },
                                React.createElement("div", { className: "cms-facet__link__image" })),
                            React.createElement("div", { className: "cms-facet__link__text" }))));
                })))));
    };
    SubcategoryNav.prototype.buildLink = function (category) {
        if (this.props.linkOverride) {
            var parts = this.props.linkOverride.split('?');
            var path = parts[0];
            var query = qs_1.parse(parts[1]);
            if (!category.rootSlug) {
                query = qs_1.stringify(tslib_1.__assign({ product_type: category.slug }, query));
            }
            else {
                query = qs_1.stringify(tslib_1.__assign({ product_type: category.rootSlug, category: category.slug }, query));
            }
            return path + "?" + query;
        }
        return category.cmsLink.href;
    };
    SubcategoryNav.prototype.getBackgroundImageStyle = function (cat) {
        var src = lodash_1.get(cat.images[0], 'source');
        if (!src)
            return null;
        return { backgroundImage: "url(" + src + ")" };
    };
    SubcategoryNav.prototype.renderParentCategories = function (parentCategories) {
        var _this = this;
        if (parentCategories.length === 0)
            return null;
        return (React.createElement("div", { className: "cms-facet__link__parents-wrapper" }, parentCategories.map(function (parent, idx) { return (React.createElement(core_link_1.default, { to: _this.buildLink(parent), entityId: parent.id, className: "cms-facet__link cms-facet__link--parent", key: idx, position: idx },
            React.createElement("span", null, parent.name))); })));
    };
    SubcategoryNav.prototype.categories = function () {
        return this.props.data.categories || [];
    };
    SubcategoryNav.prototype.renderChildrenCategories = function (childCategories) {
        var _this = this;
        if (childCategories.length === 0)
            return null;
        return (React.createElement(collapsing_facet_1.default, { count: childCategories.length, countThreshold: CMS_COLLAPSE_THRESHOLD, classPrefix: "cms-facet" },
            React.createElement("ul", { className: "cms-facet__options" }, childCategories.map(function (cat, idx) { return (React.createElement("li", { key: idx, className: "cms-facet__option" },
                React.createElement(core_link_1.default, { to: _this.buildLink(cat), entityId: cat.id, className: "cms-facet__link", key: idx, position: idx },
                    React.createElement("div", { className: "cms-facet__link__image__wrap" },
                        React.createElement("div", { className: "cms-facet__link__image", style: _this.getBackgroundImageStyle(cat) })),
                    React.createElement("div", { className: "cms-facet__link__text" }, cat.name)))); }))));
    };
    SubcategoryNav.prototype.render = function () {
        try {
            if (this.props.data.loading)
                return this.renderplaceholderNav();
            if (!this.props.data.loading && !this.categories().length) {
                return null;
            }
            var category = this.categories()[0];
            return (React.createElement("div", { className: "cms-facets", id: this.props.jumplinkSlug || null },
                React.createElement("nav", null,
                    this.renderParentCategories(category.parentCategories),
                    React.createElement("div", { className: "cms-facets__wrapper" },
                        React.createElement("div", { className: "cms-facet__link cms-facet__link--current" }, category.name),
                        this.renderChildrenCategories(category.childCategories)))));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    SubcategoryNav = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.CATEGORY_TYPE,
                context: {
                    categoryUUID: props.categoryUUID,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                }
            };
        })
    ], SubcategoryNav);
    return SubcategoryNav;
}(React.Component));
exports.SubcategoryNav = SubcategoryNav;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  query Commons_Cms_SubcategoryNav(\n    $ids: [String]\n  )\n  {\n    categories(input:{\n      ids: $ids,\n      withChildren: true,\n      withParent: true,\n    }) {\n      id\n      name\n      slug\n      rootSlug\n      cmsLink {\n        href\n      }\n      images(input:{\n        type:\"Category\",\n        count:1,\n        transform:\"card_wide\",\n        scope:\"full_bleed_brand\"\n      }) {\n        source\n      }\n      childCategories(input: {\n        withAggregations: CATEGORY_UUIDS\n      }) {\n        id\n        name\n        slug\n        rootSlug\n        cmsLink {\n          href\n        }\n        images(input:{\n          type:\"Category\",\n          count:1,\n          transform:\"card_wide\",\n          scope:\"full_bleed_brand\"\n        }) {\n          source\n        }\n      }\n      parentCategories {\n        id\n        name\n        slug\n        rootSlug\n        cmsLink {\n          href\n        }\n        images(input:{\n          type:\"Category\",\n          count:1,\n          transform:\"card_wide\",\n          scope:\"full_bleed_brand\"\n        }) {\n          source\n        }\n      }\n    }\n  }\n  "], ["\n  query Commons_Cms_SubcategoryNav(\n    $ids: [String]\n  )\n  {\n    categories(input:{\n      ids: $ids,\n      withChildren: true,\n      withParent: true,\n    }) {\n      id\n      name\n      slug\n      rootSlug\n      cmsLink {\n        href\n      }\n      images(input:{\n        type:\"Category\",\n        count:1,\n        transform:\"card_wide\",\n        scope:\"full_bleed_brand\"\n      }) {\n        source\n      }\n      childCategories(input: {\n        withAggregations: CATEGORY_UUIDS\n      }) {\n        id\n        name\n        slug\n        rootSlug\n        cmsLink {\n          href\n        }\n        images(input:{\n          type:\"Category\",\n          count:1,\n          transform:\"card_wide\",\n          scope:\"full_bleed_brand\"\n        }) {\n          source\n        }\n      }\n      parentCategories {\n        id\n        name\n        slug\n        rootSlug\n        cmsLink {\n          href\n        }\n        images(input:{\n          type:\"Category\",\n          count:1,\n          transform:\"card_wide\",\n          scope:\"full_bleed_brand\"\n        }) {\n          source\n        }\n      }\n    }\n  }\n  "]))), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            ids: [ownProps.categoryUUID],
        },
    }); },
});
exports.default = connect(SubcategoryNav);
var templateObject_1;
//# sourceMappingURL=subcategory_nav.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/subcategory_nav.js
// module id = IoA5
// module chunks = 0 2 6 20